/** Permissioned review identity. Keep the folder prefix compatible with policy purge/invalidation. */
export interface OrgPlanningReviewScope {
  readonly folderId: string;
  readonly diagramId: string;
  readonly principalId: string | null;
  readonly actorOrgId: string | null;
  readonly sessionGeneration: number;
  readonly folderGeneration: number;
}

export function orgPlanningReviewKey(scope: OrgPlanningReviewScope, changeSetId: string | null) {
  return [
    'atlas', 'organization-plan-review', scope.folderId, scope.diagramId,
    scope.principalId, scope.actorOrgId, scope.sessionGeneration, scope.folderGeneration,
    changeSetId,
  ] as const;
}

export function orgPlanningHeadsKey(scope: OrgPlanningReviewScope) {
  return [
    'atlas', 'organization-plans', scope.folderId, scope.diagramId,
    scope.principalId, scope.actorOrgId, scope.sessionGeneration, scope.folderGeneration,
  ] as const;
}

export function canReadOrgPlanningReview(scope: OrgPlanningReviewScope): boolean {
  return Boolean(scope.folderId && scope.diagramId && scope.principalId && scope.actorOrgId);
}

export function sameOrgPlanningReviewScope(left: OrgPlanningReviewScope, right: OrgPlanningReviewScope): boolean {
  return left.folderId === right.folderId && left.diagramId === right.diagramId
    && left.principalId === right.principalId && left.actorOrgId === right.actorOrgId
    && left.sessionGeneration === right.sessionGeneration && left.folderGeneration === right.folderGeneration;
}
